import { observable } from 'mobx';

export type DomesticAirLimitTypeJson = {
  id?: number;
  business_days?: number;
  hour?: number;
  allow_same_day_booking?: boolean;
};

class DomesticAirLimitType {
  @observable readonly id?: number | null;
  @observable businessDays?: number;
  @observable hour?: number;
  @observable allowSameDayBooking: boolean;

  constructor(args: DomesticAirLimitTypeJson) {
    this.id = args.id;
    this.hour = typeof args.hour === 'number' ? args.hour : 15;
    this.businessDays = typeof args.business_days === 'number' ? args.business_days : 1;
    this.allowSameDayBooking = args.allow_same_day_booking || false;
  }

  description() {
    return `${this.businessDays}営${this.hour}時`;
  }

  submitParams() {
    return {
      id: this.id,
      business_days: this.businessDays,
      hour: this.hour,
      allow_same_day_booking: this.allowSameDayBooking
    };
  }
}

export default DomesticAirLimitType;
